import React from 'react';

const AdminSidebarItem = ({
  icon,
  label,
  count,
  status = 'default',
  onClick,
}) => {
  const isDisabled = status === 'disabled';

  const baseStyles =
    'group flex w-full flex-row items-center justify-between px-6 h-10 transition-colors cursor-pointer typo-b14Strong';

  const stateStyles = {
    default:
      'bg-transparent hover:bg-grayscale-gray02 active:bg-green-light01 text-text-tertiary',
    active: 'bg-green-light01 text-green-deep03',
    disabled: 'opacity-50 cursor-not-allowed text-text-disable',
  };

  const arrowClipPath = {
    clipPath: 'polygon(0% 0%, 92% 0%, 98% 50%, 92% 100%, 0% 100%)',
  };

  return (
    <button
      type='button'
      disabled={isDisabled}
      aria-current={status === 'active' ? 'page' : undefined}
      className={`${baseStyles} ${stateStyles[status]}`}
      style={arrowClipPath}
      onClick={!isDisabled ? onClick : undefined}
    >
      <div className='flex flex-row items-center gap-2'>
        <span className={`-mt-0.5 ${isDisabled ? 'text-text-disable' : ''}`}>
          {icon}
        </span>
        <span>{label}</span>
      </div>

      <div
        className={`typo-b12Strong ${
          status === 'active' ? 'text-green-deep03' : 'text-text-tertiary'
        }`}
      >
        {count}
      </div>
    </button>
  );
};

export default AdminSidebarItem;
